export type ZaptorTheme = 'light' | 'dark';

const STORAGE_KEY = 'zaptor.theme';
const ATTRIBUTE = 'data-zaptor-theme';

function prefersDark(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return true;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function resolveInitialTheme(): ZaptorTheme {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    // privacy mode etc.
  }
  return prefersDark() ? 'dark' : 'light';
}

export function applyTheme(theme: ZaptorTheme): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute(ATTRIBUTE, theme);
}

export function saveTheme(theme: ZaptorTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}
